import React from 'react';
import { map, isEmpty } from 'lodash';
import classnames from 'classnames';
import TableList from './TableList';
import PropTypes from 'prop-types';
import { ReactComponent as Expand } from 'js/components/elements/treeview/assets/expandMoreFilled.svg';
import { SearchInjector } from 'new/elements/SearchableProvider/SearchInjector';
import { PROBE_GET_TREE_REQUEST } from 'js/constants/actionTypes';

import cx from 'classnames';
import { CircularProgress } from '@mui/material';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';

const circularProgressElement = (
  <CircularProgress size={16} style={{ marginRight: 'var(--spacing-md)', alignSelf: 'center' }} />
);

class DatabaseItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSelecting: false,
      isExpanded: this.props.selectedDatabaseId === this.props.d?.id,
    };

    this._onSelect = this._onSelect.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.isSelecting &&
      //TODO:R16 should this be deep equals?
      prevProps.probeDataFlat !== this.props.probeDataFlat &&
      this.props.probeDataFlat[this.props.d.id] &&
      this.props.probeDataFlat[this.props.d.id].scanned
    ) {
      //TODO:R16: can this be moved?
      this.setState({ isSelecting: false });
    }
  }

  handleExpand = (e) => {
    e.stopPropagation();
    this.setState((prevState) => ({ isExpanded: !prevState.isExpanded }));
  };

  _onSelect(e) {
    e.persist();
    const { d, probeDataFlat, selectedDatabaseId, selectDatabase } = this.props;
    this.handleExpand(e);

    e.stopPropagation();
    if (
      (probeDataFlat[d.id] && probeDataFlat[d.id].scanned) ||
      this.props.tablesForDatabase[d.id]?.length ||
      d.id === selectedDatabaseId
    ) {
      selectDatabase(d.id);
    } else {
      this.setState({ isSelecting: true }, () => {
        selectDatabase(d.id);
      });
    }
  }

  render() {
    const {
      d,
      selectedDatabaseId,
      tablesForDatabase,
      tables,
      selectTable,
      expandTable,
      selectedTable,
      disableSelection,
      probeDataFlat,
      connectionCategory,
      credentialId,
      shouldShowExpandedView,
      allowDatabaseSelection,
      expandedTableId,
      isProbingTree = false,
      onPreviewTable,
    } = this.props;
    const { isExpanded } = this.state;
    const selected = d.id === selectedDatabaseId;

    const onlyDatabaseSelected = isEmpty(selectedTable) && allowDatabaseSelection;

    return (
      <li
        data-testid={`database-node-${d.id}`}
        className={classnames('database-node', {
          'cdc-enabled': onlyDatabaseSelected,
        })}
      >
        <div className="database-node-content" onClick={this._onSelect}>
          {this.state.isSelecting && circularProgressElement}

          {!this.state.isSelecting && (
            <span className="database-node-handler" onClick={this._onSelect}>
              <div className="expand-icon-button">
                <Expand
                  className={cx('expand', {
                    ['expand-opened']: !isExpanded,
                    ['expand-closed']: isExpanded,
                  })}
                />
              </div>
            </span>
          )}

          <div className="database-node-detail">
            <div className={'database-item'}>
              <div className="database-icon" />
              <span className="database-title">{d.name}</span>
            </div>
          </div>
        </div>
        {isExpanded &&
          (isEmpty(tablesForDatabase[d.id]) && !this.state.isSelecting && !isProbingTree ? (
            <div className="empty-database-message">This database does not have any tables.</div>
          ) : (
            <SearchInjector>
              <TableList
                database={d}
                credentialId={credentialId}
                tables={map(tablesForDatabase[d.id], (id) => tables[id])}
                selectTable={selectTable}
                expandTable={expandTable}
                expandedTableId={expandedTableId}
                disableSelection={disableSelection}
                selectedTable={selectedTable}
                probeDataFlat={probeDataFlat}
                connectionCategory={connectionCategory}
                shouldShowExpandedView={shouldShowExpandedView}
                onPreviewTable={onPreviewTable}
              />
            </SearchInjector>
          ))}
      </li>
    );
  }
}

export default function DatabaseList({
  databases,
  credentialId,
  selectDatabase,
  selectedDatabaseId,
  tablesForDatabase,
  tables,
  selectTable,
  expandTable,
  expandedTableId,
  selectedTable,
  disableSelection,
  probeDataFlat,
  shouldShowExpandedView = true,
  connectionCategory,
  allowTableSelection,
  allowDatabaseSelection,
  onPreviewTable,
}) {
  const isProbingTree = useIsLoading(PROBE_GET_TREE_REQUEST);

  return (
    <ul className={cx('database-list', { 'no-selection': !allowTableSelection })}>
      {map(databases, (db) => (
        <DatabaseItem
          key={db.id}
          d={db}
          isProbingTree={isProbingTree}
          databases={databases}
          selectDatabase={selectDatabase}
          selectedDatabaseId={selectedDatabaseId}
          tablesForDatabase={tablesForDatabase}
          tables={tables}
          selectTable={selectTable}
          credentialId={credentialId}
          connectionCategory={connectionCategory}
          expandTable={expandTable}
          expandedTableId={expandedTableId}
          selectedTable={selectedTable}
          disableSelection={disableSelection}
          probeDataFlat={probeDataFlat}
          shouldShowExpandedView={shouldShowExpandedView}
          allowDatabaseSelection={allowDatabaseSelection}
          onPreviewTable={onPreviewTable}
        />
      ))}
    </ul>
  );
}
